import React from "react";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import { Stack as MuiStack } from "@mui/material";

import { formatItem } from "@framework/exchange";
import type { IMerge } from "@framework/types";
import { Card, List, Typography } from "@dzambalaorg/ui-kit";

import { AllowanceInfoPopover } from "../../../../../../components/dialogs/allowance";
import { MergeButton } from "../../../../../../components/buttons";

export interface IMergeItemPanelProps {
  merge: IMerge;
}

export const MergeItemPanel = (props: IMergeItemPanelProps) => {
  const { merge } = props;

  return (
    <Card sx={{ height: "fit-content", justifyContent: "flex-start" }}>
      <Card.Content>
        <MuiStack direction="row" justifyContent="space-between">
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.recipes.ingredients" />
          </Typography>
          <AllowanceInfoPopover />
        </MuiStack>
        <List>
          {merge.price?.components.map((component, i) => (
            <List.ItemButton<typeof RouterLink>
              key={component.id || i}
              component={RouterLink}
              to={`/${component.tokenType.toLowerCase()}/templates/${component.templateId}`}
            >
              <List.ItemText>{formatItem({ id: i, components: [component] })}</List.ItemText>
            </List.ItemButton>
          ))}
        </List>
      </Card.Content>
      <Card.Footer>
        <MergeButton merge={merge} />
      </Card.Footer>
    </Card>
  );
};
